import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'

import { getTargetOffsetTop, arrayReverse } from 'js/utils/Utils'
import { clamp, roundEx, lerp } from 'js/utils/Maths'

import ScrollProgressAnimation from 'js/modules/_base/effects/ScrollProgressAnimation'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'footerMainScrollProgressAnimation',
  $names: {
    footerMain: '[data-scroll-progress-anim="footer-main"]',
    footerMainInner: '[data-scroll-progress-anim="footer-main-inner"]',
    footerMainLogo: '[data-scroll-progress-anim="footer-main-logo"]',
    footerMainLogoI: '[data-scroll-progress-anim="footer-main-logo-i"]',
    footerMainLine: '[data-scroll-progress-anim="footer-main-line"]',
  },
  effectInfo: {
    innerTranslateYFactor: 30,
    logoAnimationStart: 0.15,
    lineLerpFactor: 0.25,
    logoLerpFactor: 0.2,
  },
}

export default class FooterMainScrollProgressAnimation extends ScrollProgressAnimation {
  $contentRoot = document
  $footerMain = null
  $footerMainInner = null
  $footerMainLogo = null
  $footerMainLogoItems = []
  $footerMainLogoItemFirst = null
  $footerMainLine = null

  contentEnd = 0
  footerMainLogoItemsLength = 0
  footerMainWidth = 0
  footerMainTop = 0
  footerMainHeight = 0
  wh = 0
  footerMainLogoItemFirstWidth = 0

  // isInViewFooterMainLogoItemFirst = false

  footerMainLogoItemFirstTranslateAmount = 0
  footerMainLogoItemFirstTranslateProgress = 0
  footerMainLogoItemFirstTranslateProgressLerp = 0
  footerMainLogoItemFirstTranslateParameter = 0
  footerMainLogoItemInfo = []

  progressLine = 0

  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
    this._set$()
    this._setLayout()
    this._setLogoInfo()
    this._addIoms()
    this.initStyle()
  }

  destroy() {
    super.destroy()
    this._removeIoms()
  }

  _set$() {
    if (this.$contentRoot) {
      this.$footerMain = this.$contentRoot.querySelector(this.$names.footerMain)
      this.$footerMainInner = this.$contentRoot.querySelector(this.$names.footerMainInner)
      this.$footerMainLogo = this.$contentRoot.querySelector(this.$names.footerMainLogo)
      this.$footerMainLogoItems = this.$contentRoot.querySelectorAll(this.$names.footerMainLogoI)
      this.footerMainLogoItemsLength = this.$footerMainLogoItems.length
      if (this.footerMainLogoItemsLength) {
        this.$footerMainLogoItemFirst = this.$footerMainLogoItems[0]
      }

      this.$footerMainLine = this.$contentRoot.querySelector(this.$names.footerMainLine)
    }
  }

  _addIoms() {
    // Common.iom3.add(
    //   this.$footerMainLogoItemFirst,
    //   () => {
    //     if (!this.isInViewFooterMainLogoItemFirst) {
    //       this.isInViewFooterMainLogoItemFirst = true
    //     }
    //   },
    //   () => {
    //     if (this.isInViewFooterMainLogoItemFirst) {
    //       this.isInViewFooterMainLogoItemFirst = false
    //     }
    //   }
    // )
  }

  _removeIoms() {}

  _setLogoInfo() {
    this.footerMainLogoItemFirstTranslateParameter = 1 - this.effectInfo.logoAnimationStart
    this.footerMainLogoItemFirstTranslateParameterSplit = this.footerMainLogoItemFirstTranslateParameter / this.footerMainLogoItemsLength

    if (this.footerMainLogoItemsLength) {
      this.$footerMainLogoItems.forEach(($footerMainLogoItem, i) => {
        this.footerMainLogoItemInfo[i] = {
          translateProgress: 0,
          translateProgressLerp: 0,
          start: this.effectInfo.logoAnimationStart + this.footerMainLogoItemFirstTranslateParameterSplit + this.footerMainLogoItemFirstTranslateParameterSplit * i,
          end: this.effectInfo.logoAnimationStart + this.footerMainLogoItemFirstTranslateParameterSplit * i + this.footerMainLogoItemFirstTranslateParameterSplit * 2,
        }
      })

      this.footerMainLogoItemInfo = arrayReverse(this.footerMainLogoItemInfo)
    }
  }

  initStyle() {
    if (this.footerMainLogoItemsLength) {
      this.$footerMainLogoItems.forEach(($footerMainLogoItem, i) => {
        if (i !== 0) {
          gsap.set($footerMainLogoItem, {
            y: '100%',
            rotate: 0.001,
            force3D: false,
          })
        }
      })
    }
  }

  get start() {
    return Math.max(this.footerMainTop - this.wh, 0)
  }

  get end() {
    return Math.min(this.contentEnd, this.start + Math.min(this.footerMainHeight, this.wh))
  }

  _setLayout() {
    this.wh = window.innerHeight
    this.contentEnd = document.body.scrollHeight - this.wh
    if (this.$footerMain) {
      const rect = this.$footerMain.getBoundingClientRect()
      this.footerMainWidth = rect.width
      this.footerMainHeight = rect.height
      this.footerMainTop = getTargetOffsetTop(this.$footerMain)
    }

    if (this.$footerMainLogoItemFirst) {
      this.footerMainLogoItemFirstWidth = this.$footerMainLogoItemFirst.getBoundingClientRect().width
    }

    this.footerMainLogoItemFirstTranslateAmount = this.footerMainWidth - this.footerMainLogoItemFirstWidth
  }

  updateParallax() {
    if (this.$footerMainInner) {
      const progress = this.progress
      const roundedProgress = roundEx(progress, 1000)
      const translateY = (1 - roundedProgress) * -this.effectInfo.innerTranslateYFactor
      this.$footerMainInner.style.transform = `translate(0, ${translateY}%) rotate(0.001deg)`
    }

    if (this.$footerMainLogoItemFirst) {
      const translateX = this.footerMainLogoItemFirstTranslateAmount * (1 - this.footerMainLogoItemFirstTranslateProgressLerp)

      this.$footerMainLogoItemFirst.style.transform = `translate(${translateX}px, 0) rotate(0.001deg)`
    }

    if (this.$footerMainLine) {
      let progressLine = this.progress * 1.9
      progressLine = clamp(progressLine, 0, 1)

      this.progressLine = lerp(this.progressLine, progressLine, this.effectInfo.lineLerpFactor / Common.raf.fpsMultiplier)
      const translateX = (1 - this.progressLine) * 100

      // console.log(scaleX)
      // this.$footerMainLine.style.transform = `translate(${translateX}%, 0) rotate(0.001deg)`
      // this.$footerMainLine.style.transform = `scaleX(${scaleX}) rotate(0.001deg)`
    }

    this.footerMainLogoItemFirstTranslateProgress = (this.progress - this.effectInfo.logoAnimationStart) / this.footerMainLogoItemFirstTranslateParameter
    this.footerMainLogoItemFirstTranslateProgress = clamp(this.footerMainLogoItemFirstTranslateProgress, 0, 1)
    this.footerMainLogoItemFirstTranslateProgressLerp = lerp(this.footerMainLogoItemFirstTranslateProgressLerp, this.footerMainLogoItemFirstTranslateProgress, this.effectInfo.logoLerpFactor / Common.raf.fpsMultiplier)

    this.footerMainLogoItemFirstTranslateProgressLerp = roundEx(this.footerMainLogoItemFirstTranslateProgressLerp, 1000)
    this.$footerMainLogo.style.transform = `translate(0, ${(1 - this.footerMainLogoItemFirstTranslateProgressLerp) * 80}px) rotate(0.001deg)`

    this.footerMainLogoItemInfo.forEach((itemInfo, i) => {
      if (i !== 0) {
        if (this.$footerMainLogoItems[i]) {
          itemInfo.translateProgress = (this.progress - itemInfo.start) / (itemInfo.end - itemInfo.start)
          itemInfo.translateProgress = clamp(itemInfo.translateProgress, 0, 1)
          itemInfo.translateProgressLerp = lerp(itemInfo.translateProgressLerp, itemInfo.translateProgress, this.effectInfo.logoLerpFactor / Common.raf.fpsMultiplier)
          itemInfo.translateProgressLerp = roundEx(itemInfo.translateProgressLerp, 1000)

          let translateY = (1 - itemInfo.translateProgressLerp) * 100
          translateY = roundEx(translateY, 100)

          this.$footerMainLogoItems[i].style.transform = `translate3d(0, ${translateY}%, 0)`
        }
      }
    })
  }

  onResize() {
    this._setLayout()
  }

  onRaf() {
    this.updateParallax()
  }
}